module.exports = __webpack_public_path__ + "static/media/music.beb43dc4.svg";